import * as React from 'react';
import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { IconButton, Switch, Box, TextField, Typography, Container, Button } from '@mui/material';
import { GridToolbar, GridColDef } from '@mui/x-data-grid';
import Grid from '@mui/material/Grid2';
import AddIcon from '@mui/icons-material/Add';
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
// import EditSquareIcon from '@mui/icons-material/EditSquare';
import AddCardIcon from '@mui/icons-material/AddCard';
import ImageIcon from '@mui/icons-material/Image';
import { getSingleProductServicesByID } from '../../../services/api/ProductAPI';
import { StyledDataGrid } from '../../component/ThemeComponent';
import ServiceProductForm from '../../../components/common/ServiceProduct';
import { ServiceProduct } from 'types/serviceProduct';
import PlanFieldDevelop from '../../common/PlanFieldDevelop';
import PlanCreation from '../../common/PlanCreation';
import { updatePlanStatus } from '../../../services/api/PlansAPI';
import PlanView from '../../common/PlanView';
import PlanEdit from '../../common/PlanEdit';
import ViewServiceProduct from '../../common/ViewServiceProduct';

export interface FieldValuesWithID {
	label: string;
	value: string;
	_id: string;
}

export interface OttAppsFieldValues {
	_id: string;
	imageUrl: string;
	name: string;
	status: number;
}

export interface PlansListProps {
	_id: string;
	fieldValues: FieldValuesWithID[];
	internetSpeed: string;
	offer: string;
	offerImages: string[];
	ottApps: OttAppsFieldValues[];
	price: number;
	validity: string;
	status: number;
	createdAt: string;
	updatedAt: string;
}

const PlansPage: React.FC = () => {
	const { slug } = useParams();

	const [searchText, setSearchText] = useState<string>('');
	const [open, setOpen] = useState<boolean>(false);
	const [openViewModel, setOpenViewModel] = useState<boolean>(false);
	const [openPlanFieldModel, setOpenPlanFieldModel] = useState<boolean>(false);
	const [openPlanCUModel, setOpenPlanCUModel] = useState<boolean>(false);
	const [openPlanViewModel, setOpenPlanViewModel] = useState<boolean>(false);
	// const [openPlanViewModel, setOpenPlanViewModel] = useState<boolean>(true);
	const [openPlanEditModel, setOpenPlanEditModel] = useState<boolean>(false);
	const [serviceProduct, setServiceProduct] = useState<ServiceProduct | undefined>(undefined);
	const [rows, setRows] = useState<PlansListProps[]>([]);
	const [rows2, setRows2] = useState<ServiceProduct[]>([]);
	const [productName, setProductName] = useState<string>('');
	const [serviceName, setServiceName] = useState<string>('');
	const [serviceIdSet, setServiceIdSet] = useState<string>('');
	const [planId, setPlanId] = useState('');

	const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
		setSearchText(event.target.value);
	};

	const handleViewDetails = (service: ServiceProduct) => {
		setServiceProduct(service);
		setOpenViewModel(true);
	};

	const handlePlanFieldCreate = (service: ServiceProduct) => {
		setServiceProduct(service);
		setOpenPlanFieldModel(true);
	};

	const handlePlanFieldUpdate = (service: ServiceProduct) => {
		setServiceProduct(service);
		setOpenPlanFieldModel(true);
	};

	const handleEditDetails = (service: ServiceProduct) => {
		setServiceProduct(service);
		setOpen(true);
		setServiceIdSet(service._id);
	};

	const fetchdataorder = async () => {
		if (!slug) return;
		const response = await getSingleProductServicesByID(slug);
		if (response.success) {
			const { data } = response;
			if (data.isPlanStructure) {
				if (data.plans && data.plans.plans) {
					setRows(data.plans.plans);
				} else {
					setRows([]);
				}
				setProductName(data.productName);
				setServiceName(data.serviceName);
			} else {
				setRows2([data]);
				console.log('data==========>', data);
				setProductName(data.productName);
				setServiceName(data.serviceName);
			}
			setServiceProduct(data);
		} else {
			console.error('Failed to fetch services');
		}
	};

	const handleStatusChange = async (order: PlansListProps) => {
		const updatedStatus = order.status === 1 ? 0 : 1;

		const formData = new FormData();
		formData.append('status', updatedStatus.toString());

		// const response = await updatePlanStatus(formData, order._id);
		const response = await updatePlanStatus({ status: updatedStatus }, order._id);
		if (response) {
			console.log('Status updated successfully');
			setRows(
				rows.map((row) => (row._id === order._id ? { ...row, status: updatedStatus } : row))
			);
		} else {
			console.error('Failed to update status');
		}
	};

	useEffect(() => {
		fetchdataorder();
	}, [slug]);

	useEffect(() => {
		window.scrollTo({ top: 0, behavior: 'smooth' });
	}, []);

	const handleOpenPlanCUModel = () => {
		serviceProduct?.plans &&
			Object.keys(serviceProduct.plans).length > 0 &&
			setPlanId((serviceProduct.plans as { _id: string })._id);
		setOpenPlanCUModel(true);
	};
	const handleOpenPlanEditModel = async (order: PlansListProps) => {
		setPlanId(order._id);
		setOpenPlanEditModel(true);
	};
	const handleOpenPlanViewModel = async (order: PlansListProps) => {
		setPlanId(order._id);
		setOpenPlanViewModel(true);
	};

	const handleClose = () => {
		setOpen(false);
		setOpenViewModel(false);
		setOpenPlanFieldModel(false);
		setOpenPlanCUModel(false);
		setOpenPlanViewModel(false);
		setOpenPlanEditModel(false);
	};

	const handleSuccess = () => {
		fetchdataorder();
	};

	const handleUpdate = () => {
		fetchdataorder();
	};

	// const filteredRows = serviceProduct?.isPlanStructure
	// 	? rows.filter((row) => {
	// 			const searchLower = searchText.toLowerCase();
	// 			return (
	// 				row.price?.toString().toLowerCase().includes(searchLower) ||
	// 				row.offer?.toLowerCase().includes(searchLower) ||
	// 				row.validity?.toLowerCase().includes(searchLower)
	// 			);
	// 		})
	// 	: rows2?.filter((row2) =>
	// 			row2?.serviceName?.toLowerCase().includes(searchText.toLowerCase())
	// 		);

	const filteredRows = serviceProduct?.isPlanStructure
		? [...rows].reverse().filter((row) => {
				const searchLower = searchText.toLowerCase();
				return (
					row.price?.toString().toLowerCase().includes(searchLower) ||
					row.offer?.toLowerCase().includes(searchLower) ||
					row.validity?.toLowerCase().includes(searchLower)
				);
			})
		: [...rows2]
				.reverse()
				.filter((row2) =>
					row2?.serviceName?.toLowerCase().includes(searchText.toLowerCase())
				);
	const columns: GridColDef[] = [
		{
			field: '_id',
			headerName: 'PlanID',
			width: 250,
			align: 'center',
			headerAlign: 'center',
			renderCell: (params) => (
				<Box
					sx={{
						width: '100%',
						height: '100%',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						cursor: 'pointer',
					}}
					onClick={() => handleOpenPlanViewModel(params.row)}
				>
					<Typography
						sx={{
							textAlign: 'center',
						}}
					>
						{params.value}
					</Typography>
				</Box>
			),
		},
		{
			field: 'price',
			headerName: 'Plan Price',
			width: 150,
			align: 'center',
			headerAlign: 'center',
		},
		{
			field: 'validity',
			headerName: 'Validity',
			width: 150,
			align: 'center',
			headerAlign: 'center',
		},
		{
			field: 'internetSpeed',
			headerName: 'Internet Speed',
			width: 150,
			align: 'center',
			headerAlign: 'center',
		},
		{
			field: 'status',
			headerName: 'Status',
			width: 100,
			type: 'string',
			renderCell: (params) => (
				<Switch
					checked={params.row.status === 1}
					onChange={() => handleStatusChange(params.row)}
				/>
			),
			align: 'center',
			headerAlign: 'center',
		},
		{
			field: 'offer',
			headerName: 'Offer / Plan Benefit Name',
			width: 100,
			align: 'center',
			headerAlign: 'center',
		},
		{
			field: 'actions',
			headerName: 'Actions',
			width: 200,
			align: 'center',
			headerAlign: 'center',
			renderCell: (params) => (
				<>
					<IconButton onClick={() => handleOpenPlanViewModel(params.row)}>
						<VisibilityIcon />
					</IconButton>
					<IconButton onClick={() => handleOpenPlanEditModel(params.row)}>
						<EditIcon />
					</IconButton>
				</>
			),
		},
	];

	// const columns2: GridColDef[] = [
	// 	{
	// 		field: '_id',
	// 		headerName: 'PlanID',
	// 		width: 250,
	// 	},
	// 	{
	// 		field: 'price',
	// 		headerName: 'Plan Price',
	// 		width: 150,
	// 		align: 'center',
	// 		headerAlign: 'center',
	// 	},
	// 	{
	// 		field: 'validity',
	// 		headerName: 'Validity',
	// 		width: 150,
	// 		align: 'center',
	// 		headerAlign: 'center',
	// 	},
	// 	{
	// 		field: 'internetSpeed',
	// 		headerName: 'Internet Speed',
	// 		width: 150,
	// 		align: 'center',
	// 		headerAlign: 'center',
	// 	},
	// 	{
	// 		field: 'status',
	// 		headerName: 'Status',
	// 		width: 100,
	// 		type: 'string',
	// 		renderCell: (params) => (
	// 			<Switch
	// 				checked={params.row.status === 1}
	// 				onChange={() => handleStatusChange(params.row)}
	// 			/>
	// 		),
	// 		align: 'center',
	// 		headerAlign: 'center',
	// 	},
	// 	{
	// 		field: 'offer',
	// 		headerName: 'Plan Detail',
	// 		width: 100,
	// 		align: 'center',
	// 		headerAlign: 'center',
	// 		renderCell: (params) => (
	// 			<>
	// 				{params.row.isPlanStructure ? (
	// 					params.row.plans && Object.keys(params.row.plans).length > 0 ? (
	// 						<IconButton onClick={() => handlePlanFieldUpdate(params.row)}>
	// 							<EditSquareIcon />
	// 						</IconButton>
	// 					) : (
	// 						<IconButton onClick={() => handlePlanFieldCreate(params.row)}>
	// 							<AddCardIcon />
	// 						</IconButton>
	// 					)
	// 				) : (
	// 					<IconButton onClick={() => handleViewDetails(params.row)}>
	// 						<ImageIcon />
	// 					</IconButton>
	// 				)}
	// 			</>
	// 		),
	// 	},
	// 	{
	// 		field: 'actions',
	// 		headerName: 'Actions',
	// 		width: 200,
	// 		align: 'center',
	// 		headerAlign: 'center',
	// 		renderCell: (params) => (
	// 			<>
	// 				<IconButton onClick={() => handleViewDetails(params.row)}>
	// 					<VisibilityIcon />
	// 				</IconButton>
	// 				<IconButton onClick={() => handleEditDetails(params.row)}>
	// 					<EditIcon />
	// 				</IconButton>
	// 			</>
	// 		),
	// 	},
	// ];

	const columns3: GridColDef[] = [
		{
			field: 'serviceName',
			headerName: 'Service Name',
			width: 250,
		},
		{
			field: 'isFancyNumber',
			headerName: 'Fancy Number',
			width: 150,
			align: 'center',
			headerAlign: 'center',
		},
		{
			field: 'isDTH',
			headerName: 'DTH',
			width: 150,
			align: 'center',
			headerAlign: 'center',
		},
		{
			field: 'isPlanStructure',
			headerName: 'Service Structure Type',
			width: 150,
			align: 'center',
			headerAlign: 'center',
			renderCell: (params) => (
				<Box
					sx={{
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						width: '100%',
						height: '100%',
					}}
				>
					<Typography>
						{params.row.isPlanStructure ? 'Plan Type' : 'Image Type'}
					</Typography>
				</Box>
			),
		},
		{
			field: '_id',
			headerName: 'Plan Field',
			width: 100,
			align: 'center',
			headerAlign: 'center',
			renderCell: (params) => (
				<>
					{params.row.isPlanStructure ? (
						params.row.plans && Object.keys(params.row.plans).length > 0 ? (
							<IconButton onClick={() => handlePlanFieldUpdate(params.row)}>
								<EditIcon />
							</IconButton>
						) : (
							<IconButton onClick={() => handlePlanFieldCreate(params.row)}>
								<AddCardIcon />
							</IconButton>
						)
					) : (
						<IconButton onClick={() => handleViewDetails(params.row)}>
							<ImageIcon />
						</IconButton>
					)}
				</>
			),
		},
		{
			field: 'actions',
			headerName: 'Actions',
			width: 200,
			align: 'center',
			headerAlign: 'center',
			renderCell: (params) => (
				<>
					<IconButton onClick={() => handleViewDetails(params.row)}>
						<VisibilityIcon />
					</IconButton>
					<IconButton onClick={() => handleEditDetails(params.row)}>
						<EditIcon />
					</IconButton>
				</>
			),
		},
	];

	return (
		<Container>
			<Box sx={{ width: '100%' }}>
				<div
					style={{
						display: 'flex',
						justifyContent: 'space-between',
						alignItems: 'center',
					}}
				>
					<div style={{ width: '100%' }}>
						<Typography
							gutterBottom
							style={{ fontFamily: 'Poppins', fontWeight: 700, fontSize: '24px' }}
							color="secondary"
						>
							{(serviceProduct && `${productName} - ${serviceName}`) ||
								'Service Product'}
						</Typography>

						<Box
							sx={{
								display: 'flex',
								justifyContent: serviceProduct?.isPlanStructure
									? 'space-between'
									: 'flex-start',
								alignItems: 'center',
								flexDirection: { xs: 'column', sm: 'row', md: 'row' },
								width: '100%',
								gap: 2,
								mt: 1,
							}}
						>
							<Typography
								style={{
									fontFamily: 'Poppins',
									fontWeight: 400,
									fontSize: '16px',
								}}
								color="secondary"
							>
								Manage your product, add new products, and more.
							</Typography>

							{serviceProduct?.isPlanStructure && (
								<>
									{Object.keys(serviceProduct?.plans).length > 0 ? (
										<Button
											sx={{ width: { xs: '100%', sm: 'auto' } }}
											variant="contained"
											color="primary"
											onClick={handleOpenPlanCUModel}
											startIcon={<AddIcon />}
										>
											Add Plan
										</Button>
									) : (
										<>
											{serviceProduct?.isDTH ? (
												<>
													<Button
														sx={{ width: { xs: '100%', sm: 'auto' } }}
														variant="contained"
														color="primary"
														onClick={handleOpenPlanCUModel}
														startIcon={<AddIcon />}
													>
														Add Plan
													</Button>
												</>
											) : (
												<>
													<Button
														sx={{ width: { xs: '100%', sm: 'auto' } }}
														variant="contained"
														color="primary"
														onClick={() =>
															handlePlanFieldCreate(serviceProduct)
														}
														startIcon={<AddIcon />}
													>
														Add Plan Fields
													</Button>
												</>
											)}
										</>
									)}
								</>
							)}
						</Box>
					</div>
				</div>

				<Grid container spacing={2} sx={{ mb: 2, mt: 2 }}>
					<Grid size={{ xs: 12, sm: 12, md: 12 }}>
						<TextField
							label="Search"
							variant="outlined"
							value={searchText}
							onChange={handleSearch}
							fullWidth
							style={{ fontFamily: 'Poppins' }}
							size="small"
							placeholder="Search by plan validity or price or offer"
						/>
					</Grid>
				</Grid>
				<Box sx={{ height: 600, width: 'auto' }}>
					{serviceProduct?.isPlanStructure ? (
						// serviceProduct?.isDTH ? (
						<StyledDataGrid
							rows={filteredRows}
							columns={columns}
							initialState={{
								pagination: {
									paginationModel: { pageSize: 10 },
								},
							}}
							pageSizeOptions={[10]}
							slots={{ toolbar: GridToolbar }}
							getRowId={(row) => row._id}
						/>
					) : (
						// ) : (
						// 	<StyledDataGrid
						// 		rows={filteredRows}
						// 		columns={columns2}
						// 		initialState={{
						// 			pagination: {
						// 				paginationModel: { pageSize: 10 },
						// 			},
						// 		}}
						// 		pageSizeOptions={[10]}
						// 		slots={{ toolbar: GridToolbar }}
						// 		getRowId={(row) => row._id}
						// 	/>
						// )
						<StyledDataGrid
							rows={filteredRows}
							columns={columns3}
							initialState={{
								pagination: {
									paginationModel: { pageSize: 10 },
								},
							}}
							pageSizeOptions={[10]}
							slots={{ toolbar: GridToolbar }}
							getRowId={(row) => row._id}
						/>
					)}
				</Box>
			</Box>

			{serviceProduct && (
				<ServiceProductForm
					serviceProduct={serviceProduct}
					open={open}
					handleClose={handleClose}
					productNameProvide={
						(productName as 'Airtel' | 'Jio' | 'Vi' | 'Tata') || 'Airtel'
					}
					onSuccess={handleSuccess}
					serviceId={serviceProduct._id || serviceIdSet || '000000'}
				/>
			)}

			<ViewServiceProduct
				serviceProduct={serviceProduct}
				open={openViewModel}
				handleClose={handleClose}
				productNameProvide={(productName as 'Airtel' | 'Jio' | 'Vi' | 'Tata') || 'Airtel'}
			/>

			{openPlanFieldModel && (
				<PlanFieldDevelop
					serviceProduct={serviceProduct}
					open={openPlanFieldModel}
					handleClose={handleClose}
					productNameProvide={
						(productName as 'Airtel' | 'Jio' | 'Vi' | 'Tata') || 'Airtel'
					}
					onSuccess={handleSuccess}
				/>
			)}
			{openPlanCUModel && (
				<PlanCreation
					serviceProduct={serviceProduct}
					open={openPlanCUModel}
					handleClose={handleClose}
					productNameProvide={
						(productName as 'Airtel' | 'Jio' | 'Vi' | 'Tata') || 'Airtel'
					}
					onSuccess={handleUpdate}
					planId={planId}
				/>
			)}
			{openPlanViewModel && (
				<PlanView
					serviceProduct={serviceProduct}
					open={openPlanViewModel}
					handleClose={handleClose}
					productNameProvide={
						(productName as 'Airtel' | 'Jio' | 'Vi' | 'Tata') || 'Airtel'
					}
					planId={planId}
				/>
			)}
			{openPlanEditModel && (
				<PlanEdit
					serviceProduct={serviceProduct}
					open={openPlanEditModel}
					handleClose={handleClose}
					productNameProvide={
						(productName as 'Airtel' | 'Jio' | 'Vi' | 'Tata') || 'Airtel'
					}
					planId={planId}
					onSuccess={handleUpdate}
				/>
			)}
		</Container>
	);
};

export default PlansPage;
